import React from 'react'
import cx from 'classnames'

import Link from '@cinch/oxd-components/link/src'
import SVG from '@cinch/oxd-components/svg/src'
import Text from '@cinch/oxd-components/text/src'
import { RightArrow } from '@cinch/oxd-components/icons/src'

import styles from './banner.module.css'

interface BannerProps {
  roundedCorners?: boolean
  title: string
  subTitle?: string
  icon?: string
  rightArrow?: boolean
  href: string
  tag?: Cinch.AnalyticsTag
}

const Banner: React.FC<BannerProps> = ({ roundedCorners, title, subTitle, icon, rightArrow, href, tag }) => (
  <Link to={href} className={cx(styles.banner, { [styles.roundedCorners]: roundedCorners })} tag={tag}>
    <div className={cx(styles.bannerInner)}>
      {icon && <SVG size={27} children={icon} className={styles.bannerIcon} data-testid="icon" />}
      <div className={styles.headings}>
        <Text className={styles.title} element={'h3'}>
          {title}
        </Text>
        {subTitle && (
          <Text className={styles.subTitle} element={'p'}>
            {subTitle}
          </Text>
        )}
      </div>
      {rightArrow && <SVG size={25} children={RightArrow} className={styles.arrowIcon} />}
    </div>
  </Link>
)

export default Banner
